import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';
import { measurementDto } from './measurement.req.dto';

const executionResultDto = z.object({
  errorMessage: z.string().nullable(),
  startedAt: z.string(),
  finishedAt: z.string(),
});

const operationExecutionResult = z.object({
  operationId: z.string(),
  result: executionResultDto,
});

const processExecutionResultDto = z.object({
  lastWarning: z.string().nullable(),
  result: executionResultDto,
});

export enum ProcessErrorBehavior {
  Ignore = 'Ignore',
  AbortNoCharge = 'AbortNoCharge',
  AbortNoChargeLock = 'AbortNoChargeLock',
  AbortCharge = 'AbortCharge',
  AbortChargeLock = 'AbortChargeLock',
}

const stageExecutionResultDto = z.object({
  errorBehavior: z.nativeEnum(ProcessErrorBehavior).nullable(),
  result: executionResultDto,
});

export const measurementProcessDto = z.object({
  formulaSetId: z.string(),
  bodyMeasurementSubsystemVersion: z.string().nullable(),
  measurement: measurementDto.nullable(),
  operationExecutionResults: z.array(operationExecutionResult),
  processName: z.string(),
  processVersion: z.string(),
  processorExecutionResult: processExecutionResultDto,
  stageExecutionResult: stageExecutionResultDto,
});

export class MeasurementProcessDto extends createZodDto(
  measurementProcessDto,
) {}
